import React from 'react';
import { Box, Divider, Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';
import { useTeamsChatTargetUserGroups } from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

export const TargetUserGroupsTeamsChat = () => {
  const props = useTeamsChatTargetUserGroups();
  return <TargetUserGroups {...props} />;
};

const General = () => {
  const { t } = useTranslation();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const mipFeatureShow = !!selectedOrgGlobalSetting?.mipFeatureShow;
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={mipFeatureShow}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        <TargetUserGroupsTeamsChat />
      </Flex>
    </Box>
  );
};
export default React.memo(General);
